import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/img/icon/action/edit.svg'
import _imports_1 from '@/assets/img/icon/action/copy.svg'
import _imports_2 from '@/assets/img/icon/action/reset.svg'
import _imports_3 from '@/assets/img/icon/action/change-bus.svg'
import _imports_4 from '@/assets/img/icon/action/delete.svg'
import _imports_5 from '@/assets/img/icon/action/edit-roster-blue-outline.svg'
import _imports_6 from '@/assets/img/icon/action/deactive-roster-blue-outline.svg'
import _imports_7 from '@/assets/img/icon/action/bus-outline-blue.svg'
import _imports_8 from '@/assets/img/icon/action/change-status-roster-blue-outline.svg'
import _imports_9 from '@/assets/img/icon/action/list-fill-blue.svg'


const _hoisted_1 = { class: "mr-5" }
const _hoisted_2 = { class: "flex items-center" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "mr-3 w-4",
  alt: "edit"
}, null, -1)
const _hoisted_4 = { class: "color-grey-5" }
const _hoisted_5 = { class: "flex items-center" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  class: "mr-3 w-4",
  alt: "copy"
}, null, -1)
const _hoisted_7 = { class: "color-grey-5" }
const _hoisted_8 = { class: "flex items-center" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  class: "mr-3 w-4",
  alt: "edit"
}, null, -1)
const _hoisted_10 = { class: "color-grey-5" }
const _hoisted_11 = { class: "flex items-center" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  class: "mr-3 w-4",
  alt: "change"
}, null, -1)
const _hoisted_13 = { class: "color-grey-5" }
const _hoisted_14 = { class: "flex items-center" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  class: "mr-3 w-4",
  alt: "del"
}, null, -1)
const _hoisted_16 = { class: "color-danger" }
const _hoisted_17 = { class: "flex items-center" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_5,
  class: "mr-3 w-4",
  alt: "editRoster"
}, null, -1)
const _hoisted_19 = { class: "" }
const _hoisted_20 = { class: "flex items-center" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_6,
  class: "mr-3 w-4",
  alt: "deactiveRoster"
}, null, -1)
const _hoisted_22 = { class: "" }
const _hoisted_23 = { class: "flex items-center" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_7,
  class: "mr-3 w-4",
  alt: "changeVehicleRoster"
}, null, -1)
const _hoisted_25 = { class: "" }
const _hoisted_26 = { class: "flex items-center" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_8,
  class: "mr-3 w-4",
  alt: "changeStatusRoster"
}, null, -1)
const _hoisted_28 = { class: "" }
const _hoisted_29 = { class: "flex items-center" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_9,
  class: "mr-3 w-4",
  alt: "viewPassengerLog"
}, null, -1)
const _hoisted_31 = { class: "" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("ul", null, [
      ($props.edit)
        ? (_openBlock(), _createElementBlock("li", {
            key: 0,
            class: "cursor-pointer py-1",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('edit')))
          }, [
            _createElementVNode("div", _hoisted_2, [
              _hoisted_3,
              _createElementVNode("span", _hoisted_4, _toDisplayString($props.editTitle), 1)
            ])
          ]))
        : _createCommentVNode("", true),
      ($props.copy)
        ? (_openBlock(), _createElementBlock("li", {
            key: 1,
            class: "cursor-pointer py-1",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('copy')))
          }, [
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              _createElementVNode("span", _hoisted_7, _toDisplayString($props.copyTitle), 1)
            ])
          ]))
        : _createCommentVNode("", true),
      ($props.reset)
        ? (_openBlock(), _createElementBlock("li", {
            key: 2,
            class: "cursor-pointer py-1",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('reset')))
          }, [
            _createElementVNode("div", _hoisted_8, [
              _hoisted_9,
              _createElementVNode("span", _hoisted_10, _toDisplayString($props.resetTitle), 1)
            ])
          ]))
        : _createCommentVNode("", true),
      ($props.change)
        ? (_openBlock(), _createElementBlock("li", {
            key: 3,
            class: "cursor-pointer py-1",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('change')))
          }, [
            _createElementVNode("div", _hoisted_11, [
              _hoisted_12,
              _createElementVNode("span", _hoisted_13, _toDisplayString($props.changeTitle), 1)
            ])
          ]))
        : _createCommentVNode("", true),
      ($props.del)
        ? (_openBlock(), _createElementBlock("li", {
            key: 4,
            class: "cursor-pointer py-1",
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('del')))
          }, [
            _createElementVNode("div", _hoisted_14, [
              _hoisted_15,
              _createElementVNode("span", _hoisted_16, _toDisplayString($props.delTitle), 1)
            ])
          ]))
        : _createCommentVNode("", true),
      ($props.editRoster)
        ? (_openBlock(), _createElementBlock("li", {
            key: 5,
            class: "cursor-pointer py-1",
            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('editRoster')))
          }, [
            _createElementVNode("div", _hoisted_17, [
              _hoisted_18,
              _createElementVNode("span", _hoisted_19, _toDisplayString($props.editRosterTitle), 1)
            ])
          ]))
        : _createCommentVNode("", true),
      ($props.deactiveRoster)
        ? (_openBlock(), _createElementBlock("li", {
            key: 6,
            class: "cursor-pointer py-1",
            onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$emit('deactiveRoster')))
          }, [
            _createElementVNode("div", _hoisted_20, [
              _hoisted_21,
              _createElementVNode("span", _hoisted_22, _toDisplayString($props.deactiveRosterTitle), 1)
            ])
          ]))
        : _createCommentVNode("", true),
      ($props.changeVehicleRoster)
        ? (_openBlock(), _createElementBlock("li", {
            key: 7,
            class: "cursor-pointer py-1",
            onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.$emit('changeVehicleRoster')))
          }, [
            _createElementVNode("div", _hoisted_23, [
              _hoisted_24,
              _createElementVNode("span", _hoisted_25, _toDisplayString($props.changeVehicleRosterTitle), 1)
            ])
          ]))
        : _createCommentVNode("", true),
      ($props.changeStatusRoster)
        ? (_openBlock(), _createElementBlock("li", {
            key: 8,
            class: "cursor-pointer py-1",
            onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.$emit('changeStatusRoster')))
          }, [
            _createElementVNode("div", _hoisted_26, [
              _hoisted_27,
              _createElementVNode("span", _hoisted_28, _toDisplayString($props.changeStatusRosterTitle), 1)
            ])
          ]))
        : _createCommentVNode("", true),
      ($props.viewPassengerLog)
        ? (_openBlock(), _createElementBlock("li", {
            key: 9,
            class: "cursor-pointer py-1",
            onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.$emit('viewPassengerLog')))
          }, [
            _createElementVNode("div", _hoisted_29, [
              _hoisted_30,
              _createElementVNode("span", _hoisted_31, _toDisplayString($props.viewPassengerLogTitle), 1)
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}